var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKubaInformationIconsSet3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63.178 80.178",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    y2: -321.47,
    gradientUnits: "userSpaceOnUse",
    x2: 909.22,
    gradientTransform: "translate(-396.87 167.42)",
    y1: -320.5,
    x1: 838.01
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c97e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006798"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    y2: 258.77,
    gradientUnits: "userSpaceOnUse",
    x2: 1333,
    gradientTransform: "matrix(.6386 0 0 1.5659 -399.07 -160.9)",
    y1: 237.96,
    x1: 1313.4
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.727
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    y2: 400.04,
    gradientUnits: "userSpaceOnUse",
    x2: 832.68,
    gradientTransform: "translate(-399.01 -162.24)",
    y1: 362.58,
    x1: 808.13
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-415.03 -196.71)"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(45)",
    rx: 6,
    ry: 6,
    height: 48.18,
    width: 48.18,
    y: -178.46,
    x: 453.15,
    fill: "#166496"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(45)",
    rx: 3,
    ry: 3,
    height: 42.857,
    width: 42.857,
    y: -175.8,
    x: 455.81,
    stroke: "#fff",
    strokeWidth: 1.188,
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.73 220.52h-1.62c-2.9.53-4.47.77-6.99.96v1.42l.96.1c2.47.23 3.13 1.09 3.13 3.94v11.17c0 2.62-.85 3.71-2.94 3.95l-1.19.1v1.42h12.74v-1.42l-1.14-.1c-2.14-.24-2.95-1.33-2.95-3.95v-17.59m-2.19-8.03c-1.61 0-2.9 1.28-2.9 2.85 0 1.62 1.29 2.9 2.86 2.9 1.61 0 2.9-1.28 2.9-2.85s-1.29-2.9-2.86-2.9",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.61 199.23c-.76 0-1.53.29-2.12.87l-26.07 26.07a3.012 3.012 0 000 4.25l16.66 16.65c.04-17.36 11.74-31.56 26.81-33.81l-13.15-13.16a3.03 3.03 0 00-2.13-.87z",
    fill: "url(#c)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKubaInformationIconsSet3);
export default __webpack_public_path__ + "static/media/kuba_information_icons_set_3.1e9e24c2eb8cea3eff43bb1cd19d2e27.svg";
export { ForwardRef as ReactComponent };